var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-lg leading-6 font-semibold text-gray-900 dark:text-white"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }